// extracted by mini-css-extract-plugin
export default {"courseOverview":"CourseOverview_courseOverview__dnmWs","active":"CourseOverview_active__7athy","listSections":"CourseOverview_listSections__f9ynN"};